import React, { useMemo } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { categories as propertyCategories } from '@luxuryescapes/lib-global';

interface Props {
  value: propertyCategories.CategoryName[];
  onChange: (newValue: propertyCategories.CategoryName[]) => void;
  onFocus?: () => void;
}

export default function AccommodationCategoriesFilterInput({ value, onChange, onFocus }: Props) {
  const countries = useMemo(() => propertyCategories.allCategories, []);

  return (
    <Autocomplete
      multiple
      options={countries}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      renderInput={(params) => <TextField {...params} label="Category" onFocus={onFocus} />}
      fullWidth
      openOnFocus
      clearOnEscape
    />
  );
}
